var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReflections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5H0.5C0.21875 0.5 0 0.75 0 1V3C0 3.28125 0.21875 3.5 0.5 3.5H2.5C2.75 3.5 3 3.28125 3 3V1C3 0.75 2.75 0.5 2.5 0.5ZM2.5 5.5H0.5C0.21875 5.5 0 5.75 0 6V8C0 8.28125 0.21875 8.5 0.5 8.5H2.5C2.75 8.5 3 8.28125 3 8V6C3 5.75 2.75 5.5 2.5 5.5ZM2.5 10.5H0.5C0.21875 10.5 0 10.75 0 11V13C0 13.2812 0.21875 13.5 0.5 13.5H2.5C2.75 13.5 3 13.2812 3 13V11C3 10.75 2.75 10.5 2.5 10.5ZM15.5 6.25H5.5C5.21875 6.25 5 6.5 5 6.75V7.25C5 7.53125 5.21875 7.75 5.5 7.75H15.5C15.75 7.75 16 7.53125 16 7.25V6.75C16 6.5 15.75 6.25 15.5 6.25ZM15.5 11.25H5.5C5.21875 11.25 5 11.5 5 11.75V12.25C5 12.5312 5.21875 12.75 5.5 12.75H15.5C15.75 12.75 16 12.5312 16 12.25V11.75C16 11.5 15.75 11.25 15.5 11.25ZM15.5 1.25H5.5C5.21875 1.25 5 1.5 5 1.75V2.25C5 2.53125 5.21875 2.75 5.5 2.75H15.5C15.75 2.75 16 2.53125 16 2.25V1.75C16 1.5 15.75 1.25 15.5 1.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflections);
export default __webpack_public_path__ + "static/media/reflections.5a5af568.svg";
export { ForwardRef as ReactComponent };